import React from 'react'
import styled from 'styled-components'
import { MAX_CHARACTER_COUNT } from '~/constants/config'
import { light } from '~/constants/theme'

import { FontStyle, Text } from './core'

const Wrapper = styled.div`
  position: absolute;
  bottom: -15px;
  right: 0px;
`

const CharacterCount = ({ count = 0 }) => {
  return (
    <Wrapper>
      <Text
        color={count <= MAX_CHARACTER_COUNT ? light.dark800 : light.red200}
        fontStyle={FontStyle.SuperTiny}
      >
        {count} / {MAX_CHARACTER_COUNT}
      </Text>
    </Wrapper>
  )
}

export default CharacterCount
